<template>
  <div class="logo-inverted-main-content" id="identidade-visual-logo-versao-principal-invertida" data-search-anchor>
    <div class="logo-inverted-main-title-wrapper">
      <h1 class="logo-inverted-main-span">{{ logoInvertedMainVersionTitleSpan }}</h1>
      <h1 class="logo-inverted-main-title">{{ logoInvertedMainVersionTitle }}</h1>
    </div>
    <div class="logo-inverted-main-description-wrapper">
      <div>
        <p class="logo-inverted-main-description">{{ logoInvertedMainVersionDescription }}</p>
        <p class="logo-inverted-main-description1">{{ logoInvertedMainVersionDescription1 }}</p>
      </div>

      <div class="logo-inverted-main-icon">
        <IconCheck />
        <p class="logo-inverted-main-description2">{{ logoInvertedMainVersionDescription2 }}</p>
      </div>
    </div>
    <div
      class="logo-inverted-main-card-item"
      :style="{ backgroundImage: `url(${logoInvertedMainVersionImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LogoInvertedMainVersionSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoInvertedMainVersionTitleSpan(): string {
    return this.getElementTitle(5, 0)
  }

  get logoInvertedMainVersionTitle(): string {
    return this.getElementText(5, 0)
  }

  get logoInvertedMainVersionDescription(): string {
    return this.getElementText(5, 1)
  }

  get logoInvertedMainVersionDescription1(): string {
    return this.getElementText(5, 2)
  }

  get logoInvertedMainVersionDescription2(): string {
    return this.getElementText(5, 3)
  }

  get logoInvertedMainVersionImageSrc(): string {
    return this.getElementMedia(5, 4)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-inverted-main-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.logo-inverted-main-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-inverted-main-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-inverted-main-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.logo-inverted-main-icon {
  display: flex;
  align-items: center;
  margin-bottom: 4.5rem;
}

.logo-inverted-main-description-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;   
}

.logo-inverted-main-description,
.logo-inverted-main-description1 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 430px;  
}

.logo-inverted-main-description{
  margin: 0;
}

.logo-inverted-main-description2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin: 0;
  width: 378px;
  padding-left: 7px;
}

.logo-inverted-main-card-item {
  position: relative;    
    width: 100%;
    max-width: 1032px;
    height: 318px;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
</style>
